import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

ReactDOM.render(<App />, document.getElementById('root'));

